import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons';
import styles from './AddElementButton.module.scss';

interface Props {
    id?: string;
    hasSelectedElements: boolean;
    onClick: () => void;
}

export const AddElementButton: FunctionComponent<Props> = props => {
    if (props.hasSelectedElements) {
        return (
            <FontAwesomeIcon
                icon={faPlusCircle}
                className={styles.plusIcon}
                onClick={props.onClick}
            />
        );
    }

    return (
        <button
            id={props.id}
            type="button"
            className={styles.addButton}
            onClick={props.onClick}
        >
            <FontAwesomeIcon
                icon={faPlus}
                className={styles.addButtonIcon}
            />
            <span>Add</span>
        </button>
    );
};

export default AddElementButton;
